import { useCallback, useState } from 'react'

/**
 * Custom hook to provide a refresh key and a refresh function.
 * The refresh key can be used as a dependency to trigger re-fetching data
 * when the refresh function is called.
 */
export const useRefresh = () => {
  const [refreshKey, setRefreshKey] = useState(0)
  const refresh = useCallback(() => setRefreshKey((v) => v + 1), [])
  return { refreshKey, refresh }
}
